module.exports = __webpack_public_path__ + "img/1479331930.12d13926.jpg";